import styled from 'styled-components'
import { SectionHeader } from 'shared/components/text-elements'
import { giphyLightGrey, giphyCharcoal } from '@giphy/js-brand'
import DescriptionInput from 'shared/components/edit-panel/info/video-description/input'

const Container = styled.div`
    margin-bottom: 20px;
`

const Label = styled(SectionHeader)`
    color: ${giphyLightGrey};
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 8px;
`

const Requirement = styled.span`
    font-size: 12px;
    color: ${giphyCharcoal};
`

type Props = {
    value?: string
    onChange: (data: object) => void
}

const VideoDescription = ({ value = '', onChange = () => {} }: Props) => {
    return (
        <Container>
            <Label>
                <span>Video Description</span>
                <Requirement>Optional</Requirement>
            </Label>
            <DescriptionInput value={value} onChange={(value) => onChange({ videoDescription: value })} />
        </Container>
    )
}

export default VideoDescription
